webpackJsonp([183886176117593],{

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic07.f5dbbc42.jpg";

/***/ }),

/***/ 518:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic08.0bb08756.jpg";

/***/ }),

/***/ 131:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/pic09.b598bd94.jpg";

/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BannerLandingClaims = function BannerLandingClaims(props) {
	    return _react2.default.createElement(
	        "section",
	        { id: "banner", className: "style2" },
	        _react2.default.createElement(
	            "div",
	            { className: "inner" },
	            _react2.default.createElement(
	                "header",
	                { className: "major" },
	                _react2.default.createElement(
	                    "h1",
	                    null,
	                    "Claims & payments"
	                )
	            ),
	            _react2.default.createElement(
	                "div",
	                { className: "content" },
	                _react2.default.createElement(
	                    "h2",
	                    null,
	                    "Methodology, calculations, and health care benefits"
	                )
	            )
	        )
	    );
	};
	
	exports.default = BannerLandingClaims;
	module.exports = exports["default"];

/***/ }),

/***/ 219:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(18);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(25);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _BannerLandingClaims = __webpack_require__(212);
	
	var _BannerLandingClaims2 = _interopRequireDefault(_BannerLandingClaims);
	
	var _pic = __webpack_require__(518);
	
	var _pic2 = _interopRequireDefault(_pic);
	
	var _pic3 = __webpack_require__(131);
	
	var _pic4 = _interopRequireDefault(_pic3);
	
	var _pic5 = __webpack_require__(517);
	
	var _pic6 = _interopRequireDefault(_pic5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Landing = function Landing(props) {
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                'Claims Processing'
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: 'Claims processing' })
	        ),
	        _react2.default.createElement(_BannerLandingClaims2.default, null),
	        _react2.default.createElement(
	            'div',
	            { id: 'main' },
	            _react2.default.createElement(
	                'section',
	                { id: 'one' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'inner' },
	                    _react2.default.createElement(
	                        'header',
	                        { className: 'major' },
	                        _react2.default.createElement(
	                            'h2',
	                            null,
	                            'Who was eligible to make a claim?'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Two distinct groups of beneficiaries were able to claim under the Arrangement:'
	                    ),
	                    _react2.default.createElement(
	                        'ol',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'The first group consisted of individuals injured in the disaster and who lost earning capacity as a consequence.  This included anyone who was in the Rana Plaza building at the time of collapse, rescue workers and others who may had been injured in the adjacent buildings. '
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'The second group covered dependents either of fatal victims or of people who were reportedly missing  as result of the Rana Plaza incident (including workers, rescue workers etc). In this category, claims were made by those who were partially or fully reliant on the income earned by the  person killed or considered missing. '
	                        )
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'section',
	                { id: 'two', className: 'spotlights' },
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/claims-process', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic2.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'How were claims submitted and processed?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The claims system established under the Arrangement was designed to make sure the process was accessible and easy to understand for beneficiaries. The claims process had a number of stages.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/claims-process', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/calculations', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic4.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'How were claims calculated?'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The method of calculating the awards was designed in accordance with the principles of ILO Employment Injury Benefits Convention No. 121. '
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The formula took into consideration each individual\'s particular circumstances. Therefore, variables such as  the age of the beneficiary, the number of dependents that each claim must cover, the wage earned by the killed or injured worker and the extent of injury suffered in the case of survivors were all factors that influenced the value of the award. '
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/calculations', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    null,
	                    _react2.default.createElement(
	                        _gatsbyLink2.default,
	                        { to: '/healthcare', className: 'image' },
	                        _react2.default.createElement('img', { src: _pic6.default, alt: '' })
	                    ),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'content' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'inner' },
	                            _react2.default.createElement(
	                                'header',
	                                { className: 'major' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    null,
	                                    'Health care and related benefits'
	                                )
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'The Arrangement also addressed health care needs of victims injured in the accident. A medical assessment by qualified doctors exercising independent professional judgment projected the required care that would allow victims to  attain pre-injury health condition or maximum recovery.'
	                            ),
	                            _react2.default.createElement(
	                                'p',
	                                null,
	                                'Two separate schemes were then set up under the Arrangement, to ensure ongoing medical treatment. For those workers with a more serious permanent disablement arrangements were made with the Bangladesh NGO BRAC, while for the remaining injured workers a special Trust for Injured Workers Medical Care was established.'
	                            ),
	                            _react2.default.createElement(
	                                'ul',
	                                { className: 'actions' },
	                                _react2.default.createElement(
	                                    'li',
	                                    null,
	                                    _react2.default.createElement(
	                                        _gatsbyLink2.default,
	                                        { to: '/healthcare', className: 'button' },
	                                        'Learn more'
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = Landing;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-claims-js-e35a51dce42960ce1b2e.js